export default __webpack_public_path__ + "static/benefits.url-d46b5f39c0a06b734388c4a74d848166.svg";